export default (node) => (node.depth === 0 ? true : false);
